import { SystemBaseApi } from "./SystemBaseApi";
import { Methods } from '@newview/infrastructure';

/**
 * Api
 */
export class LogInforApi extends SystemBaseApi {
    public get ControllerName(): any {
        return 'loginfor'
    }

    /**
     * 查询登录日志
     * @param current 
     * @param size 
     */
    public getLoginForList(current,size){
        return this.send({current:current,size:size},"getLoginForList",Methods.GET)
    }

    
   
}
